import { BaseModel } from '@/api/base-model'
import { BadgeType } from '@/api/types'
import { User } from '@/api/model/user'

export class GamificationScore extends BaseModel<GamificationScore> {
    protected collectionName = 'gamification_score'

    constructor(
        public id: string,
        public year: number,
        public quarter: number,
        public type: BadgeType,
        public score: number,
        public relativeScore: number,
        public user: User,
    ) { super(id) }

    static fromData(data: any): GamificationScore {
        if (data === null || typeof data === 'string' || data instanceof GamificationScore) {
            return data
        }

        return new GamificationScore(
            data.id,
            data.year,
            data.quarter,
            data.type,
            data.score,
            data.relativeScore,
            data.user ? User.fromData(data.user) : null,
        )
    }
}
